import React from "react";
import AboutUs from "./AboutUs";
import Team from "./Team";
import Contact from "./Contact";
import ContactForm from "./ContactForm";
import Slider from "./Slider";
import ImageSlider from "./ImageSlider";
import ImageSliderEmployees from "./ImageSliderEmployees";
import RetirementNotice from "./RetirementNotice";
import JobsLink from "./JobsLink";

const Startseite = React.createClass({
    render: function () {
        return (
            <div>
                <AboutUs />
                <Team />
                <ImageSliderEmployees />
                <RetirementNotice />
                <Slider />
                <JobsLink />
                <ContactForm />
                <ImageSlider />
                <Contact />
            </div>
        );
    },
});

export default Startseite;



// WEBPACK FOOTER //
// ./src/js/containers/Startseite.js